// extracted by mini-css-extract-plugin
module.exports = {"warrap":"warrap___2TVa4","collapsible":"collapsible___3O-71"};